<script setup lang="ts">
import { Form } from 'vee-validate'
import { formRegisterSchema } from '~/validate/forms/auth'
import { AUTH_CRITERIA } from '~/validate/constant/auth'
import { REGEX_NUMBER } from '~/constants'
import { useRegister } from '~/composables/account/use-register'
import BaseButton from '~/components/common/base-button.vue'
import UserIcon from '~/assets/images/icons/user-icon.svg'
import PasswordIcon from '~/assets/images/icons/password-icon.svg'
import PhoneIcon from '~/assets/images/icons/phone-icon.svg'
import BaseInput from '~/components/common/base-input.vue'

const {
  user,
  handleSubmitRegister,
  resetError,
  messageError,
  messageUsernameExist,
  messageDisplayNameExist,
  resetDisplaynameError,
  resetUsernameError,
  checkDisplayName
} = useRegister()

const onDisplayNameBlur = (inpValue: string) => {
  checkDisplayName(inpValue)
}
</script>

<template>
  <Form
    v-slot="{ isSubmitting, meta: { valid } }"
    class="form"
    name="form-register"
    :validationSchema="formRegisterSchema"
    @submit="handleSubmitRegister"
  >
    <BaseInput
      v-model="user.username"
      type="text"
      name="username"
      label="Tên đăng nhập"
      hasRequiredMark
      :maxLength="AUTH_CRITERIA.USER_NAME_MAX_LENGTH"
      :errorCustom="messageError || messageUsernameExist"
      :isLabelFloating="true"
      :iconPrepend="UserIcon"
      @input="resetUsernameError"
    />
    <BaseInput
      v-model="user.displayName"
      type="text"
      name="displayName"
      label="Tên hiển thị"
      :maxLength="AUTH_CRITERIA.DISPLAY_NAME_MAX_LENGTH"
      :errorCustom="messageDisplayNameExist"
      :isLabelFloating="true"
      :iconPrepend="UserIcon"
      @input="resetDisplaynameError"
      @onFocusOut="onDisplayNameBlur"
    />

    <BaseInput
      v-model="user.password"
      type="password"
      name="password"
      label="Mật khẩu"
      hasRequiredMark
      :maxLength="AUTH_CRITERIA.PASSWORD_MAX_LENGTH"
      :isLabelFloating="true"
      :iconPrepend="PasswordIcon"
      @input="resetError"
    />
    <BaseInput
      v-model="user.passwordConfirm"
      type="password"
      name="passwordConfirm"
      label="Xác nhận mật khẩu"
      hasRequiredMark
      :maxLength="AUTH_CRITERIA.PASSWORD_MAX_LENGTH"
      :isLabelFloating="true"
      :iconPrepend="PasswordIcon"
      @input="resetError"
    />
    <BaseInput
      v-model="user.phone"
      type="tel"
      label="Số điện thoại"
      hasRequiredMark
      name="phone"
      :maxLength="AUTH_CRITERIA.PHONE_MAX_LENGTH"
      :isPhone="true"
      :pattern="REGEX_NUMBER"
      className="required"
      :iconPrepend="PhoneIcon"
      inputMode="numeric"
      :isLabelFloating="true"
      @input="resetError"
    />
    <div class="form__btn-login mb-0">
      <BaseButton
        type="submit"
        class="button"
        :loadingButton="isSubmitting"
        :disable="Boolean(isSubmitting || !valid || messageError || messageUsernameExist || messageDisplayNameExist)"
        size="extra-large"
      >
        Đăng ký ngay
      </BaseButton>
    </div>
  </Form>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/auth/form-auth.scss';
</style>
